import { SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

const ListPageSkeleton: FC = () => (
  <div className="p-4 pb-6 flex flex-col gap-4">
    <div className="flex items-center justify-between gap-4">
      <SkeletonLoader className="h-7 w-40 rounded" />
      <div className="flex items-center gap-2">
        <SkeletonLoader className="h-8 w-28 rounded-lg" />
        <SkeletonLoader className="h-8 w-32 rounded-lg" />
      </div>
    </div>

    <div className="flex items-center gap-2">
      <SkeletonLoader className="h-9 w-72 rounded-lg" />
      <SkeletonLoader className="h-9 w-24 rounded-lg" />
      <SkeletonLoader className="h-9 w-24 rounded-lg" />
    </div>

    <div className="border rounded-lg overflow-hidden">
      {/* oxlint-disable-next-line payaca/no-tailwind-arbitrary-values -- Mixed grid template has no utility */}
      <div className="grid grid-cols-[2fr_1fr_1fr_1fr_auto] gap-4 px-4 py-3 border-b bg-gray-50">
        <SkeletonLoader.Text className="h-4 w-24" />
        <SkeletonLoader.Text className="h-4 w-20" />
        <SkeletonLoader.Text className="h-4 w-20" />
        <SkeletonLoader.Text className="h-4 w-16" />
        <SkeletonLoader.Square className="h-4 w-4" />
      </div>
      {Array.from({ length: 8 }).map((_, i) => (
        <div
          key={i}
          // oxlint-disable-next-line payaca/no-tailwind-arbitrary-values -- Mixed grid template has no utility
          className="grid grid-cols-[2fr_1fr_1fr_1fr_auto] gap-4 px-4 py-4 border-b last:border-b-0 items-center"
        >
          <div className="flex items-center gap-3">
            <SkeletonLoader.Circle className="h-8 w-8 shrink-0" />
            <SkeletonLoader.Text className="h-4 w-48" />
          </div>
          <SkeletonLoader.Text className="h-4 w-28" />
          <SkeletonLoader.Text className="h-4 w-24" />
          <SkeletonLoader.Text className="h-4 w-20" />
          <SkeletonLoader.Square className="h-5 w-5" />
        </div>
      ))}
    </div>
  </div>
);

export default ListPageSkeleton;
